import type {
    MirrorAxisGeometryProvider,
} from '../../../types/sketch/mirror/SketchMirrorAxisReferenceTypes';
import type {
    SketchMirrorAxisReferenceProvider,
} from '../../sketch/entities-transform/SketchMirrorAxisReferenceProvider';

/**
 * 判断草图对象是否实现统一镜像轴几何协议。
 * @param value 待判断对象。
 * @returns 同时具备草图对象身份和正式解析方法时返回 true。
 */
export function isMirrorAxisGeometryProvider(value: unknown): value is MirrorAxisGeometryProvider {
    return (typeof value === 'object' || typeof value === 'function')
        && value !== null
        && Reflect.get(value, 'isSketchObject') === true
        && typeof Reflect.get(value, 'resolveMirrorAxisGeometry') === 'function';
}

/**
 * 判断对象是否为承载外部稳定引用的镜像轴 provider。
 * @param value 待判断对象。
 * @returns 命中外部引用对象的领域标记时返回 true。
 */
export function isSketchMirrorAxisReferenceProvider(
    value: unknown,
): value is SketchMirrorAxisReferenceProvider {
    return isMirrorAxisGeometryProvider(value)
        && Reflect.get(value, 'isSketchMirrorAxisReferenceProvider') === true;
}
